import { CHECKOUT_TYPE, CHECKOUT_VARIANT } from "../constants.checkout";
import { TCheckoutType, TCheckoutVariant } from "../types.checkout";

export function getCheckoutVariant(
  checkoutType: TCheckoutType,
): TCheckoutVariant {
  if (checkoutType == CHECKOUT_TYPE.MIGRATION)
    return CHECKOUT_VARIANT.MIGRATION;
  if (checkoutType == CHECKOUT_TYPE.MANAGE) return CHECKOUT_VARIANT.MANAGE;
  if (checkoutType == CHECKOUT_TYPE.PURCHASE) return CHECKOUT_VARIANT.PURCHASE;
  else return CHECKOUT_VARIANT.UNKNOWN;
}
